export const capitalizeFirstLetter = (inputString) => {
  if (typeof inputString !== 'string' || inputString.length === 0) {
    return ''
  }

  try {
    const firstChar = inputString.charAt(0).toUpperCase()
    const restOfString = inputString.slice(1).toLowerCase()
    return firstChar + restOfString
  } catch (error) {
    return ''
  }
}

export const formatNumberWithDecimals = (number, decimalPlaces = 2) => {
  if (
    typeof decimalPlaces !== 'number' ||
    !Number.isInteger(decimalPlaces) ||
    decimalPlaces < 0
  ) {
    return null
  }

  if (typeof number !== 'number' || !isFinite(number)) {
    return null
  }

  try {
    return number.toFixed(decimalPlaces)
  } catch (error) {
    return null
  }
}
